function getTimeInZone(timezone) {
  return new Date(new Date().toLocaleString('en-US', { timeZone: timezone }));
}

function parseCutoff(now, cutoffTime) {
  const [hours, minutes] = cutoffTime.split(':').map(Number);
  const cutoff = new Date(now);
  cutoff.setHours(hours, minutes, 0, 0);

  if (now >= cutoff) {
    cutoff.setDate(cutoff.getDate() + 1);
  }

  return cutoff;
}

class DeliveryTimer extends HTMLElement {
  connectedCallback() {
    window.clearInterval(this.updateInterval);

    this.hoursElement = this.querySelector('.js-hours');
    this.minutesElement = this.querySelector('.js-minutes');
    this.dateElement = this.querySelector('.js-date');

    if (!this.hoursElement || !this.minutesElement || !this.dateElement) {
      return;
    }

    this.update();
    this.updateInterval = window.setInterval(() => this.update(), 60000);
  }

  disconnectedCallback() {
    window.clearInterval(this.updateInterval);
  }

  update() {
    const timezone = this.dataset.timezone || 'Europe/Oslo';
    const cutoffTime = this.dataset.cutoff || '20:00';
    const deliveryDays = Number.parseInt(this.dataset.days || '5', 10);
    const locale = this.dataset.locale || 'en-US';
    const now = getTimeInZone(timezone);
    const cutoff = parseCutoff(now, cutoffTime);
    const difference = cutoff - now;
    const hours = Math.floor(difference / 3600000);
    const minutes = Math.floor((difference % 3600000) / 60000);

    this.hoursElement.textContent = String(hours).padStart(2, '0');
    this.minutesElement.textContent = String(minutes).padStart(2, '0');

    const delivery = new Date(now);
    delivery.setDate(delivery.getDate() + deliveryDays);

    this.dateElement.textContent = delivery.toLocaleDateString(locale, {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    });
  }
}

if (!window.customElements.get('delivery-timer')) {
  window.customElements.define('delivery-timer', DeliveryTimer);
}
